export default "__VITE_ASSET__D0Kzt0DH__"